// polyfills

import 'core-js/actual'
import 'wicg-inert'
import '@oddbird/popover-polyfill'
if (!('anchorName' in document.documentElement.style)) {
	import('@oddbird/css-anchor-positioning')
}
import { popoverTooltipDirective } from '#helpers/directive-tooltip-popover.js'
import i18n from '#helpers/i18n/i18n.js'
import { initMatomo } from '@certible/use-matomo'
import * as Sentry from '@sentry/vue'
import { createHead } from '@unhead/vue/client'
import { createPinia } from 'pinia'
import PortalVue from 'portal-vue'
import { TemplateParamsPlugin } from 'unhead/plugins'
import { createApp } from 'vue'

import pack from '../package.json'
import App from './App.vue'
import router from './router/routes.js'

const app = createApp(App)
const head = createHead({
	init: [
		{
			title: 'Home',
			titleTemplate: '%s %separator %siteName',
			templateParams: { separator: '—', siteName: import.meta.env.VITE_APP_NAME },
		},
	],
	plugins: [TemplateParamsPlugin],
})
app.use(createPinia())
app.use(router)
app.use(head)
app.use(i18n)
app.use(PortalVue)
app.provide(
	'matomo',
	initMatomo({
		host: 'https://statistics.carenet.dev',
		siteId: 1,
		trackRouter: true,
		enableLinkTracking: true,
	}),
)

if (
	import.meta.env.VITE_SENTRY_DSN &&
	import.meta.env.VITE_SENTRY_ENV &&
	import.meta.env.VITE_SENTRY_ENV !== 'local'
) {
	// Sentry.io error logging
	Sentry.init({
		app,
		dsn: import.meta.env.VITE_SENTRY_DSN,
		integrations: [
			Sentry.browserTracingIntegration({ router }),
			Sentry.replayIntegration({ maskAllText: false }),
		],
		replaysSessionSampleRate: 0.05,
		replaysOnErrorSampleRate: 0.5,
		tracesSampleRate: Number(import.meta.env.VITE_SENTRY_SAMPLE_RATE ?? 0),
		release: `nfo-frontend@${pack.version}`,
		environment: import.meta.env.VITE_SENTRY_ENV,
		trackComponents: true,
	})
}

app.directive('tip', popoverTooltipDirective)

app.mount('#root')

export default app
